import P from '../pages';
import appReducer from './reducers';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { setPage, setNextPage, setPreviousPage } from '../../../shared/actions';

const pageNavigator = store => next => action => {
  let result = next(action);
  let {
    page,
    pages,
    terms,
    registered,
    content,
    nextPage,
    previousPage,
    marketing_referrers,
    environment,
    guestType,
    referral,
    products,
    language_options,
    ethnicity_options,
    arrival_times,
    country_code,
    affiliate,
    territoryId,
    territoryCode,
    territory,
    address,
    profileElements
  } = store.getState();
  let placementEntry = profileElements.find(entry => entry.kind === "placement");
  let departureTransport = placementEntry?.answers?.departure_transport;
  let next_page, previous_page;
  if (page && pages.length > 0){
    let included_pages = departureTransport == 'Yes' ? pages : pages.filter(page => page !== "departure");
    let index = included_pages.indexOf(page);
    let first_page = included_pages[0];

    if (index > -1) {
      next_page = included_pages[index+1];
      previous_page = included_pages[index-1];
    }

    if (page == P.EDUCATION_PAGE && !pages.includes('education')){
      store.dispatch(setPage(P.PLACEMENT_PAGE))
    } else if (page == P.PRODUCT_PAGE && !pages.includes('product')){
      store.dispatch(setPage(P.GUARDIAN_EMERGENCY_PAGE))
    } else if ((page == P.REGISTER_PAGE || page == P.ADDRESS_PAGE || page == P.FIREBASE_ACCOUNT_DETAILS_FORM_PAGE) && registered) {
      store.dispatch(setPage(P.PRODUCT_PAGE))
    } else if (page != P.ADDRESS_PAGE && !registered && !address && territory.guest_address_check){
      store.dispatch(setPage(P.ADDRESS_PAGE))
    } else if ((page != P.REGISTER_PAGE && page != P.FIREBASE_REGISTER_FORM_PAGE && page != P.FIREBASE_ACCOUNT_DETAILS_FORM_PAGE) && !registered && (address || !territory.guest_address_check)) {
      if (territory.enable_firebase_authentication) {
        store.dispatch(setPage(P.FIREBASE_REGISTER_FORM_PAGE))
      } else {
        store.dispatch(setPage(P.REGISTER_PAGE))
      }
    } else if (nextPage) {
      store.dispatch(setNextPage(false))
      store.dispatch(setPage(next_page))
    } else if (previousPage) {
      store.dispatch(setPreviousPage(false))
      store.dispatch(setPage(previous_page))
    }
  }
  window.gs = store.getState()
  return result;
};

export default createStore(
  appReducer,
  applyMiddleware(thunk,pageNavigator)
)
